import styled from 'styled-components'

export const Container = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
`;

export const Header = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
    margin-bottom: 15px;
    padding-bottom: 15px;
    border-bottom: 1px solid ${({ theme }) => theme.colors.border || '#eee'};
`;

export const HeaderInfo = styled.div`
    display: flex;
    flex-direction: column;
    gap: 2px;
`;

export const Title = styled.h4`
    color: ${({ theme }) => theme.colors.text};
    margin: 0;
`;

export const Subtitle = styled.span`
    font-size: 13px;
    color: ${({ theme }) => theme.colors.textSecondary || '#999'};
`;

export const HeaderActions = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 8px;
`;

export const SearchWrapper = styled.div`
    width: 100%;
    margin-bottom: 20px;
`;

export const Content = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
    gap: 12px;
    margin: 0;
`;

export const BorderCard = styled.div`
    background-color: ${({ theme }) => theme.colors.backgroundSecondary || '#f9f9f9'};
    border: 1px solid ${({ theme }) => theme.colors.border || '#eee'};
    padding: 14px 16px;
    border-radius: 10px;
    cursor: pointer;
    transition: box-shadow 0.2s, border-color 0.2s;

    &:hover {
        box-shadow: 0 2px 8px rgba(0,0,0,0.08);
        border-color: ${({ theme }) => theme.colors.primary};
    }

    &:hover .border-edit-icon {
        opacity: 1;
    }
`;

export const BorderCardHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 8px;
    margin-bottom: 8px;
`;

export const BorderCardTitle = styled.span`
    font-size: 15px;
    font-weight: 600;
    color: ${({ theme }) => theme.colors.text};
    line-height: 1.3;
`;

export const EditIcon = styled.span`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    color: ${({ theme }) => theme.colors.textSecondary || '#999'};
    opacity: 0;
    transition: opacity 0.2s;
`;

export const SizeList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
`;

export const SizeRow = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 13px;
`;

export const SizeLabel = styled.span`
    color: ${({ theme }) => theme.colors.textSecondary || '#999'};
`;

export const SizePrice = styled.span`
    color: ${({ theme }) => theme.colors.text};
    font-weight: 600;
`;

export const NoSizesText = styled.span`
    font-size: 13px;
    font-style: italic;
    color: ${({ theme }) => theme.colors.textSecondary || '#999'};
`;

export const BordersEmptyList = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    padding: 30px
`;
export const EmptyText = styled.span`
    font-size: 18px;
    color: ${({ theme }) => theme.colors.text};
    margin-bottom: 20px;
`;

export const InputGroup = styled.div`
    margin:  8px 0 ;
`;
